export const urlPath = {
  top: '/',
  contact: '/contact',
  sitePolicy: '/site-policy',
  shizutetsuSosarea: '/interview/shizutetsu-sosarea',
  urbanGate: '/interview/urban-gate',
  privacy: 'https://www.micro-wave.net/privacy/',
  company: 'https://www.micro-wave.net/company/profile/',
}
